export const GET_INVESTOR_DETAILS_ERROR = "Error in getting investor details.";
export const UPDATE_INVESTOR_ERROR = "Error in updating investor.";
export const UPDATE_INVESTOR_SUCCESS = "Investor updated successfully.";
export const SAVE_INVESTOR_ERROR = "Error in saving investor.";
export const SAVE_INVESTOR_SUCCESS = "Investor saved successfully.";
export const CREATE_INVESTOR_ERROR = "Error in creating investor.";
export const CREATE_INVESTOR_SUCCESS = "Investor created successfully.";
